import { NavLink } from "react-router-dom";
import { useTenantStore } from "../stores/tenant";

/** Raccourci d'accueil vers la configuration de l'établissement courant. */
export function MyTenantCard() {
  const { available, currentTenantId } = useTenantStore();
  const current = available.find((t) => t.id === currentTenantId);
  if (!current) return null;
  return (
    <NavLink to={`/etablissements/${current.id}`} className="card card--interactive">
      <h3 className="card__title">{current.name}</h3>
      <p className="card__subtitle">Configurer l'établissement courant</p>
    </NavLink>
  );
}
